import * as React from 'react'
import EnumCombobox, { EnumComboboxProps } from './EnumCombobox'
import { Billable } from '../../config/registration/timeConfig'
import { useMemo } from 'react'
import useViewport, { Viewport } from '../../hooks/useViewport'

export type BillableComboboxProps = Omit<EnumComboboxProps<Billable>, 'entities' | 'multiselect' | 'labelKeyPrefix'>

export default function BillableCombobox(props: BillableComboboxProps) {
    const { isViewport, viewport } = useViewport()

    const viewportSmall = useMemo<boolean>(() => isViewport('<', Viewport.OutlookNew), [viewport])

    return (
        <EnumCombobox<Billable>
            required
            entities={Object.values(Billable)}
            labelKeyPrefix={'base.billable'}
            placeholderPrefixKey={viewportSmall ? '' : undefined}
            placeholderKey={viewportSmall ? 'base.billable.placeholder.small' : 'base.billable.placeholder'}
            {...props}
        />
    )
}
